import {Actions} from "./actions";
import {IScreens} from "IncompleteInfoV2/interface";
import {IToastDetails} from "StateInterface";

export interface IState {
    screens: IScreens;
    toastDetails: IToastDetails;
    bankStatementsStatus: {
        is_bs_upload_allowed: boolean;
    };
}
const defaultState: IState = {
    screens: null,
    toastDetails: null,
    bankStatementsStatus: null,
};

export default function incompleteInfoV2(state = defaultState, action) {

    switch (action.type) {
        case Actions.SET_INCOMPLETE_INFO_SCREENS:
            return{
                ...state,
                screens: action.body,
            };
        case Actions.REMOVE_COMPLETED_SUB_STATUS:
            const {[action.body]: removedValue, ...newScreens} = state.screens;
            return {
                ...state,
                screens: {...newScreens},
            };
        case Actions.HIDE_TOAST:
            return {
                ...state,
                toastDetails: null,
            };
        case Actions.SHOW_TOAST:
            return {
                ...state,
                toastDetails: {
                    bgColor: action.body.bgColor,
                    msg: action.body.msg,
                },
            };
        case Actions.SET_BANK_STATEMENT_STATUS:
            return {
                ...state,
                bankStatementsStatus: action.body,
            };
        default:
            return state;
    }
}
